import { render, staticRenderFns } from "./assigned_workers.vue?vue&type=template&id=f2567296&scoped=true"
import script from "./assigned_workers.vue?vue&type=script&lang=js"
export * from "./assigned_workers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2567296",
  null
  
)

export default component.exports